import { Pipe, PipeTransform } from '@angular/core';
import isString from 'lodash-es/isString';

/**
 * Returns true if give colour is white or empty
 */
@Pipe({
    name: 'isWhite',
    standalone: true
})
export class IsWhitePipe implements PipeTransform {
    transform(input: string): boolean {
        if (!input) {
            return true;
        }
        if (!isString(input)) {
            return false;
        }

        input = input.toLowerCase();

        if (input === '#ffffff') {
            return true;
        }
        if (input.match(/rgb\(\s*255\s*,\s*255\s*,\s*255\s*\)/)) {
            return true;
        }
        if (input.match(/rgba\(\s*255\s*,\s*255\s*,\s*255\s*,\s*1\s*\)/)) {
            return true;
        }
        return false;
    }
}
